import "babel-polyfill";

import React from 'react';
import ResizeTextPreviewLayer from './ResizeTextPreviewLayer.js';
import ResizeSymbolPreviewLayer from './ResizeSymbolPreviewLayer.js';
import AutoscaleTextPreviewLayer from './AutoscaleTextPreviewLayer.js';
import AutoscaleSymbolSelectLayer from './AutoscaleSymbolSelectLayer.js';
import AutoscaleSymbolColorSelectLayer from "./AutoscaleSymbolColorSelectLayer";
import AutoscaleSymbolPreviewLayer from './AutoscaleSymbolPreviewLayer.js';
import PreviewLayer from './PreviewLayer.js';
import FontAwesome from 'react-fontawesome';
import update from 'immutability-helper';
import {  copy } from './functions.js';
import AutoscaleTextColorSelectLayer from "./AutoscaleTextColorSelectLayer";
import ResizeImagePreviewLayer from "./ResizeImagePreviewLayer";
import AutoscaleImagePreviewLayer from "./AutoscaleImagePreviewLayer";



class DesignerPreview extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            imageLoaded: false,
            imageSrc: this.props.activeBackground.image_url,
            imageWidth: -1,
            imageOverlayLoaded: false,
            imageOverlaySrc: this.props.activeBackground.overlay,
            imageOverlayWidth: -1,
            mobileCorrection: 1,
            hoverContentLayerId: '',
        }

        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageErrored = this.handleImageErrored.bind(this);
        this.handleImageOverlayLoaded = this.handleImageOverlayLoaded.bind(this);
        this.handleImageOverlayErrored = this.handleImageOverlayErrored.bind(this);
        this.handleSymbolSelect = this.handleSymbolSelect.bind(this);
        this.handleAutoscaleColorSelect = this.handleAutoscaleColorSelect.bind(this);
        this.handleContentLayerRemove = this.handleContentLayerRemove.bind(this);
        this.handleContentLayerChange = this.handleContentLayerChange.bind(this);
        this.handleContentLayerSelect = this.handleContentLayerSelect.bind(this);
        this.handleContentLayerUnselect = this.handleContentLayerUnselect.bind(this);
        this.handlePreviewLayerMouseEnter = this.handlePreviewLayerMouseEnter.bind(this);
        this.handlePreviewLayerMouseLeave = this.handlePreviewLayerMouseLeave.bind(this);

    }

    componentDidMount() {
        window.removeEventListener('resize', this.handleWindowResize);
        window.addEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize(e) {
        if (this.backgroundImg !== undefined &&
            this.backgroundImg !== null &&
            this.state.imageWidth != this.backgroundImg.clientWidth)
        {
            let imageWidth = this.state.imageWidth;
            let mobileCorrection = this.state.mobileCorrection;

            if (this.backgroundImg !== undefined && this.backgroundImg !== null)
            {
                const theImage = new Image();
                theImage.src = this.backgroundImg.getAttribute("src");

                mobileCorrection = theImage.width / this.backgroundImg.clientWidth;
                imageWidth = this.backgroundImg.clientWidth;
            }

            this.setState({
                imageLoaded: true,
                imageWidth: imageWidth,
                mobileCorrection: mobileCorrection,
            });
        }
    }

    componentDidUpdate() {
        if (this.props.activeBackground.image_url != this.state.imageSrc)
        {
            this.setState({
                imageLoaded: false,
                imageOverlayLoaded: false,
                imageSrc: this.props.activeBackground.image_url,
                imageOverlaySrc: this.props.activeBackground.overlay,
                imageWidth: -1,
                imageOverlayWidth: -1,
            })
        }
    }

    handleSymbolSelect(symbol, position) {
        this.props.onSymbolSelect(symbol, position);
    }

    handleAutoscaleColorSelect(color, position) {
        this.props.onAutoscaleColorSelect(color, position);
    }

    handleContentLayerRemove(layer) {
        this.props.onContentLayerRemove(layer);
    }

    handleContentLayerUnselect(e) {
        e.preventDefault();

        if (!e.target.classList.contains('layer_active_wrapper') &&
            !e.target.classList.contains('layer_handle') &&
            !e.target.classList.contains('layer_handle_icon') &&
            !e.target.classList.contains('active'))
            {
                this.props.onContentLayerSelect(-1);
            }
    }

    handleContentLayerSelect(layerIndex) {
        this.props.onContentLayerSelect(layerIndex);
    }

    handleContentLayerChange(layer) {
        this.props.onContentLayerChange(layer);
    }

    getMaxSymbolCount() {
        let max = 3;

        if (this.props.activePerspective.max_symbols > 0)
            max = this.props.activePerspective.max_symbols;

        if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
        {
            for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                    continue;

                if (this.props.activeDesignerVariants[varI].selectedVar.max_symbols > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_symbols < max)
                    max = this.props.activeDesignerVariants[varI].selectedVar.max_symbols;
            }
        }

        return max;
    }

    handleImageLoaded() {

        let imageWidth = this.state.imageWidth;
        let mobileCorrection = this.state.mobileCorrection;

        if (this.backgroundImg !== undefined && this.backgroundImg !== null && this.state.imageWidth != this.backgroundImg.clientWidth)
        {
            const theImage = new Image();
            const bgImage = this.backgroundImg;
            theImage.src = this.backgroundImg.getAttribute("src");

            theImage.onload = (event) => {

                if (bgImage)
                {
                    mobileCorrection = theImage.width / bgImage.clientWidth;
                    imageWidth = this.backgroundImg.clientWidth;

                    this.setState({
                        imageLoaded: true,
                        imageWidth: imageWidth,
                        mobileCorrection: mobileCorrection,
                    });
                }
            }
        }



    }

    handleImageOverlayLoaded() {

        let imageOverlayWidth = this.state.imageOverlayWidth;

        if (this.backgroundImg !== undefined && this.backgroundImg !== null && this.state.imageOverlayWidth != this.backgroundImg.clientWidth)
        {
            imageOverlayWidth = this.backgroundImg.clientWidth;

            this.setState({
                imageOverlayWidth: imageOverlayWidth,
            });
        }

    }

    handleImageOverlayErrored() {
        this.setState({ imageOverlayLoaded: false });
    }

    handleImageErrored() {
        this.setState({ imageLoaded: false });
    }

    handlePreviewLayerMouseEnter(contentLayer) {
        this.setState({ hoverContentLayerId: contentLayer.id });
    }

    handlePreviewLayerMouseLeave(contentLayer) {
        this.setState({ hoverContentLayerId: '' });
    }

    getMaxLineCount()
    {
        let count = 1;

        if (this.props.activePerspective.designer_mode == 'resize')
        {
            count = 3;
            if (this.props.activePerspective.max_lines > 0)
                count = this.props.activePerspective.max_lines;

            if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
            {
                for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                    if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                        continue;

                    if (this.props.activeDesignerVariants[varI].selectedVar.max_lines > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_lines < count)
                        count = this.props.activeDesignerVariants[varI].selectedVar.max_lines;
                }
            }
        }

        return count;
    }

    render() {


        const maxLinesCount = this.getMaxLineCount();

        const perspectiveLayers = this.props.contentLayers.filter((ly) => {
            return ly.perspectiveId == this.props.activePerspective.id && ly.perspective_varid == this.props.activePerspective.varid
        });

        let resizeSymbolCount = 0;
        let symbolSelectInfo = null;
        const previewLayers = [];
        const previewImageLayers = [];
        let imageLayerActive = false;
        let imageLayerHover = false;
        const hasOverlay = this.props.activeBackground.has_overlay || (this.props.designerRenderMode == 'exportresult' && this.props.activeBackground.has_exportoverlay);

        let scale = 1;


        if (this.state.mobileCorrection > 0)
            scale = 1 / this.state.mobileCorrection;

        // for (var layer = 0; layer < perspectiveLayers.length; layer++) {
        for (var layer = 0; layer < this.props.contentLayers.length; layer++) {

            // skipp other perspectives
            // if (this.props.contentLayers[layer].perspectiveId != this.props.activePerspective.id)
            //     continue;

            // let contentLayer = perspectiveLayers[layer];
            let contentLayer = this.props.contentLayers[layer];
            contentLayer.layerIndex = layer;

            const isActiveLayer = (contentLayer.layerIndex === this.props.activeLayerIndex);

            // select selectAutoscaleSymbol
            if (this.props.selectAutoscaleSymbol !== undefined && this.props.selectAutoscaleSymbol !== null)
            {
                if (contentLayer.mode == 'autoscale' &&
                    contentLayer.perspectiveId == this.props.activePerspective.id &&
                    contentLayer.perspective_varid == this.props.activePerspective.varid)
                {
                    if (contentLayer.type == 'text')
                    {
                        previewLayers.push(
                            <AutoscaleTextPreviewLayer
                                key={contentLayer.id}
                                isActiveLayer={isActiveLayer}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                activeColor={this.props.activeColor}
                                activeFont={this.props.activeFont}
                                activePerspective={this.props.activePerspective}
                                perspectiveLayers={perspectiveLayers}
                                forceHidden={true}
                                onContentLayerChange={this.handleContentLayerChange}
                                onContentLayerSelect={this.handleContentLayerSelect}
                                designerRenderMode={this.props.designerRenderMode}
                            />
                        );
                    }
                    if (contentLayer.type == 'symbol')
                    {
                        if (symbolSelectInfo === null)
                        {
                            symbolSelectInfo = (
                                <div className="symbol_select_info">
                                    <FontAwesome name='info-circle' size='2x' />&nbsp;
                                    W&auml;hle einen Bereich in dem dein Symbol platziert werden soll.
                                </div>
                            );
                        }
                        previewLayers.push(
                            <AutoscaleSymbolSelectLayer
                                key={contentLayer.id}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                symbol={this.props.selectAutoscaleSymbol}
                                onSymbolSelect={this.handleSymbolSelect}
                            />
                        );
                    }
                }
            }
            // select auto scale color
            else if (this.props.selectAutoscaleColor !== undefined && this.props.selectAutoscaleColor !== null)
            {
                if (contentLayer.mode == 'autoscale' &&
                    contentLayer.perspectiveId == this.props.activePerspective.id &&
                    contentLayer.perspective_varid == this.props.activePerspective.varid)
                {
                    if (symbolSelectInfo === null)
                    {
                        symbolSelectInfo = (
                            <div className="symbol_select_info">
                                <FontAwesome name='info-circle' size='2x' />&nbsp;
                                W&auml;hle einen Bereich zum einf&auml;rben:
                            </div>
                        );
                    }

                    if (contentLayer.type == 'text')
                    {
                        previewLayers.push(
                            <AutoscaleTextColorSelectLayer
                                key={contentLayer.id}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                perspectiveLayers={perspectiveLayers}
                                color={this.props.selectAutoscaleColor}
                                onColorSelect={this.handleAutoscaleColorSelect}
                            />
                        );
                    }
                    if (contentLayer.type == 'symbol')
                    {
                        previewLayers.push(
                            <AutoscaleSymbolColorSelectLayer
                                key={contentLayer.id}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                color={this.props.selectAutoscaleColor}
                                onColorSelect={this.handleAutoscaleColorSelect}
                            />
                        );
                    }
                }
            }
            // normal display mode
            else
            {
                if (contentLayer.mode == 'resize')
                {
                    if (contentLayer.type == 'text' && contentLayer.rowIndex < maxLinesCount)
                    {
                        previewLayers.push(
                            <ResizeTextPreviewLayer
                                key={contentLayer.id}
                                designerRenderMode={this.props.designerRenderMode}
                                designerExportBorder={this.props.designerExportBorder}
                                isActiveLayer={isActiveLayer}
                                responsiveScale={scale}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                activeColor={this.props.activeColor}
                                activeFont={this.props.activeFont}
                                activePerspective={this.props.activePerspective}
                                activeDesignerVariants={this.props.activeDesignerVariants}
                                colorPerElement={this.props.colorPerElement}
                                perspectiveLayers={perspectiveLayers}
                                onContentLayerChange={this.handleContentLayerChange}
                                onContentLayerSelect={this.handleContentLayerSelect}
                                onContentLayerRemove={this.handleContentLayerRemove}
                            />
                        );
                    }
                    else if (contentLayer.type == 'symbol')
                    {
                        if (contentLayer.perspective_varid == this.props.activePerspective.varid &&
                            contentLayer.perspectiveId == this.props.activePerspective.id)
                            resizeSymbolCount++;

                        previewLayers.push(
                            <ResizeSymbolPreviewLayer
                                key={contentLayer.id}
                                isActiveLayer={isActiveLayer}
                                responsiveScale={scale}
                                designerRenderMode={this.props.designerRenderMode}
                                designerExportBorder={this.props.designerExportBorder}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                activeColor={this.props.activeColor}
                                activeDesignerVariants={this.props.activeDesignerVariants}
                                activePerspective={this.props.activePerspective}
                                onContentLayerChange={this.handleContentLayerChange}
                                onContentLayerSelect={this.handleContentLayerSelect}
                                onContentLayerRemove={this.handleContentLayerRemove}
                            />
                        );
                    }
                    else if (contentLayer.type == 'image')
                    {
                        const layer = <AutoscaleImagePreviewLayer
                            key={contentLayer.id}
                            isActiveLayer={isActiveLayer}
                            designerRenderMode={this.props.designerRenderMode}
                            designerExportBorder={this.props.designerExportBorder}
                            layerIndex={contentLayer.layerIndex}
                            responsiveScale={scale}
                            contentLayer={contentLayer}
                            activeColor={this.props.activeColor}
                            activeDesignerVariants={this.props.activeDesignerVariants}
                            activePerspective={this.props.activePerspective}
                            hasOverlay={hasOverlay}
                            onContentLayerChange={this.handleContentLayerChange}
                            onContentLayerSelect={this.handleContentLayerSelect}
                            onContentLayerRemove={this.handleContentLayerRemove}
                            onMouseEnter={this.handlePreviewLayerMouseEnter}
                            onMouseLeave={this.handlePreviewLayerMouseLeave}
                        />;

                        if (this.props.activeBackground.has_overlay)
                        {
                            previewImageLayers.push(layer);
                        }
                        else
                        {
                            previewLayers.push(layer);
                        }
                    }
                }
                else if (contentLayer.mode == 'autoscale')
                {
                    if (contentLayer.type == 'text')
                    {
                        previewLayers.push(
                            <AutoscaleTextPreviewLayer
                                key={contentLayer.id}
                                isActiveLayer={isActiveLayer}
                                designerRenderMode={this.props.designerRenderMode}
                                designerExportBorder={this.props.designerExportBorder}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                activeColor={this.props.activeColor}
                                activeFont={this.props.activeFont}
                                activePerspective={this.props.activePerspective}
                                perspectiveLayers={perspectiveLayers}
                                onContentLayerChange={this.handleContentLayerChange}
                                onContentLayerSelect={this.handleContentLayerSelect}
                            />
                        );
                    }
                    if (contentLayer.type == 'symbol')
                    {
                        previewLayers.push(
                            <AutoscaleSymbolPreviewLayer
                                key={contentLayer.id}
                                isActiveLayer={isActiveLayer}
                                designerRenderMode={this.props.designerRenderMode}
                                designerExportBorder={this.props.designerExportBorder}
                                layerIndex={contentLayer.layerIndex}
                                contentLayer={contentLayer}
                                activeColor={this.props.activeColor}
                                activePerspective={this.props.activePerspective}
                                onContentLayerChange={this.handleContentLayerChange}
                                onContentLayerSelect={this.handleContentLayerSelect}
                                onContentLayerRemove={this.handleContentLayerRemove}
                            />
                        );
                    }
                    else if (contentLayer.type == 'image')
                    {
                        const layer = <AutoscaleImagePreviewLayer
                            key={contentLayer.id}
                            isActiveLayer={isActiveLayer}
                            designerRenderMode={this.props.designerRenderMode}
                            designerExportBorder={this.props.designerExportBorder}
                            layerIndex={contentLayer.layerIndex}
                            responsiveScale={scale}
                            contentLayer={contentLayer}
                            activeColor={this.props.activeColor}
                            activeDesignerVariants={this.props.activeDesignerVariants}
                            activePerspective={this.props.activePerspective}
                            hasOverlay={hasOverlay}
                            onContentLayerChange={this.handleContentLayerChange}
                            onContentLayerSelect={this.handleContentLayerSelect}
                            onContentLayerRemove={this.handleContentLayerRemove}
                            onMouseEnter={this.handlePreviewLayerMouseEnter}
                            onMouseLeave={this.handlePreviewLayerMouseLeave}
                        />;

                        if (this.props.activeBackground.has_overlay)
                        {
                            previewImageLayers.push(layer);
                        }
                        else
                        {
                            previewLayers.push(layer);
                        }

                    }
                }
            }
        }

        let symbolCounter = null;
        if (this.props.activePerspective.designer_mode == 'resize')
        {
            symbolCounter = (
                <div className="designer_preview_symbol_counter">
                    {resizeSymbolCount} / {this.getMaxSymbolCount()} Symbole verwendet
                </div>
            );
        }


        const previewLayerStyle = {
            WebkitTransformOrigin: 'top left',
            OTransformOrigin: 'top left',
            MsTransformOrigin: 'top left',
            MozTransformOrigin: 'top left',
            transformOrigin: 'top left',
            WebkitTransform: 'scale(' + scale + ')',
            OTransform: 'scale(' + scale + ')',
            MsTransform: 'scale(' + scale + ')',
            MozTransform: 'scale(' + scale + ')',
            transform: 'scale(' + scale + ')',
        };


        if (this.props.designerRenderMode == 'exportresult')
        {
            const borderStyle = {};
            if (this.props.activePerspective.designer_mode == 'resize' &&
                this.props.designerExportBorder &&
                perspectiveLayers != undefined &&
                perspectiveLayers.length > 0)
            {
                borderStyle.top = 0;
                borderStyle.left = 0;
                borderStyle.width = (perspectiveLayers[0].maxDimensions.width + 20) + 'px';
                borderStyle.height = (perspectiveLayers[0].maxDimensions.height + 20) + 'px';
            }

            if (this.props.activePerspective.export_pxbased == 1)
            {
                previewLayerStyle.width = this.props.activePerspective.exportpx_totalwidth + 'px';
                previewLayerStyle.height = this.props.activePerspective.exportpx_totalheight + 'px';
            }

            return (
                <div style={this.props.exportScaleStyle} className={'designer_preview designer_render_mode_' + this.props.designerRenderMode + (this.props.activePerspective.export_pxbased ? ' designer_export_pxbased': '')} onClick={this.handleContentLayerUnselect}>
                    {
                        this.props.designerExportBorder && this.props.activePerspective.designer_mode == 'resize' ?
                        <div className="designer_export_border" style={borderStyle}></div>
                        : null
                    }

                    {
                        hasOverlay ?
                            <div className="designer_preview_layers designer_preview_image_layers" style={previewLayerStyle}>
                                {previewImageLayers}
                            </div>
                            : null
                    }

                    {
                        hasOverlay ?
                            <img
                                className="designer_preview_background_overlay"
                                ref={(backgroundOverlayImg) => this.backgroundOverlayImg = backgroundOverlayImg}
                                onLoad={this.handleImageOverlayLoaded}
                                onError={this.handleImageOverlayErrored}
                                src={this.props.activeBackground.exportoverlay}
                            />
                            : null
                    }

                    <div className="designer_preview_layers" style={previewLayerStyle}>
                        {previewLayers}
                    </div>
                </div>
            );
        }

        return (
            <div className={'designer_preview designer_render_mode_' + this.props.designerRenderMode} onClick={this.handleContentLayerUnselect}>

                {this.props.designerRenderMode == 'designer' ? symbolSelectInfo : null}

                <img
                    className="designer_preview_background"
                    ref={(backgroundImg) => this.backgroundImg = backgroundImg}
                    onLoad={this.handleImageLoaded}
                    onError={this.handleImageErrored}
                    src={this.props.activeBackground.image_url}
                />

                {
                    // Render if image ist not loaded
                    !this.state.imageLoaded ?
                    <div className='designer_preview_loader'>
                        <div className="designer_preview_loader_icon">
                            <FontAwesome
                                name='circle-o-notch'
                                size='3x'
                                spin
                            />
                        </div>
                    </div>
                    : null
                }

                {
                    hasOverlay ?
                    <div className="designer_preview_layers designer_preview_image_layers" style={previewLayerStyle}>
                        {imageLayerActive ? previewLayers : null}
                        {previewImageLayers}
                    </div>
                    : null
                }

                {
                    hasOverlay ?
                    <img
                        className="designer_preview_background_overlay"
                        ref={(backgroundOverlayImg) => this.backgroundOverlayImg = backgroundOverlayImg}
                        onLoad={this.handleImageOverlayLoaded}
                        onError={this.handleImageOverlayErrored}
                        src={this.props.activeBackground.overlay}
                        style={imageLayerActive || imageLayerHover ? {opacity: 0.4 }:null}
                    />
                    : null
                }

                {
                    !hasOverlay || !imageLayerActive ?
                    <div className="designer_preview_layers" style={previewLayerStyle}>
                        {previewLayers}
                    </div>
                    : null
                }

                {this.props.designerRenderMode == 'designer' ? symbolCounter : null}
            </div>
        );
    }
  }

export default DesignerPreview;



// WEBPACK FOOTER //
// ./src/DesignerPreview.js